import React from 'react';
import { ArrowRight } from 'lucide-react';
export function GulfCoastExpertise() {
  return <section className="py-24 px-6 md:px-12 bg-white relative overflow-hidden" data-id="element-81">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#0066FF 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-82"></div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10" data-id="element-83">
        {/* Content */}
        <div className="order-2 lg:order-1" data-id="element-84">
          <div className="section-badge" data-id="element-85">OUR ROOTS</div>
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-6 leading-tight" data-id="element-86">
            GULF COAST EXPERTISE BACKED BY{' '}
            <span className="text-primary" data-id="element-87">PROVEN EXPERIENCE</span>
          </h2>
          <p className="text-gray-600 text-lg mb-8 leading-relaxed" data-id="element-88">
            Headquartered in the heart of the Gulf Coast, BND Contracting has
            deep roots in the region's industrial landscape. We understand the
            unique challenges and requirements of operating in this environment.
            Our local expertise, combined with our extensive network, allows us
            to respond quickly and effectively to the staffing needs of our
            clients across Texas, Louisiana, and beyond.
          </p>
          <button className="btn-white border border-gray-200 shadow-sm w-fit group" data-id="element-89">
            ABOUT US
            <div className="bg-primary text-white rounded-full p-1 group-hover:bg-primary-hover transition-colors" data-id="element-90">
              <ArrowRight size={16} data-id="element-91" />
            </div>
          </button>
        </div>

        {/* Image with offset border */}
        <div className="relative pr-6 pb-6 order-1 lg:order-2" data-id="element-92">
          {/* Blue offset border (bottom right) */}
          <div className="absolute bottom-0 right-0 w-[90%] h-[90%] border-8 border-primary z-0" data-id="element-93"></div>
          <img src="https://images.unsplash.com/photo-1565018054866-1006ee28e278?q=80&w=1000&auto=format&fit=crop" alt="Gulf Coast Lighthouse" className="relative z-10 w-full h-[500px] object-cover shadow-xl" data-id="element-94" />
        </div>
      </div>
    </section>;
}